/* SILK: add to cart from product cards and the drawer recommendation without leaving the page,
   then open the cart drawer (same section rendering as the product form in product.js).
   Mobile footer: Shop and Service fold on phones; Rechtliches (Impressum, Widerruf, Cookie-Einstellungen) stays open
   because those links must stay directly reachable. Desktop unchanged.
   Mobile sliders: position dots under product and ingredient sliders. */
(function () {
  var SECTIONS = [
    ['Cart', 'main-cart', '.thb-cart-form'],
    ['Cart-Drawer', 'cart-drawer', '.cart-drawer'],
    ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']
  ];

  function render(sections) {
    SECTIONS.forEach(function (s) {
      var host = document.getElementById(s[0]);
      if (!host || !sections || !sections[s[1]]) return;
      var target = host.querySelector(s[2]) || host;
      var source = new DOMParser().parseFromString(sections[s[1]], 'text/html').querySelector(s[2]);
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return false;
    if (typeof OverlayManager !== 'undefined') OverlayManager.open(drawer);
    else drawer.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.silk-card__action, form.silk-drawer-add');
    if (!form || !window.fetch || !window.theme || !theme.routes) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
    var data = new FormData(form);
    data.append('sections', SECTIONS.map(function (s) { return s[1]; }).join(','));
    data.append('sections_url', window.location.pathname);
    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { form.submit(); return; }
        render(res.sections);
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res.items ? res.items[0] : res } }));
        if (!document.getElementById('Cart')) openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
      });
  });

  // Footer link lists fold on phones
  var mq = window.matchMedia('(max-width: 767px)');
  function setupFooter() {
    var footer = document.getElementById('footer');
    if (!footer) return;
    footer.querySelectorAll('.widget').forEach(function (w, i) {
      var title = w.querySelector(':scope > .thb-widget-title');
      if (!title || !/^(Shop|Service)$/.test(title.textContent.trim())) return;
      var id = 'silk-fold-' + i;
      var body = [].slice.call(w.children).filter(function (c) { return c !== title; });
      if (mq.matches) {
        w.classList.add('silk-fold');
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
        title.setAttribute('aria-controls', id);
        if (!w.classList.contains('is-open')) title.setAttribute('aria-expanded', 'false');
        if (body[0] && !body[0].id) body[0].id = id;
      } else {
        w.classList.remove('silk-fold', 'is-open');
        ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (a) { title.removeAttribute(a); });
      }
    });
  }
  function toggle(title) {
    var w = title.closest('.silk-fold');
    if (!w) return;
    var open = w.classList.toggle('is-open');
    title.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.silk-fold > .thb-widget-title');
    if (t) toggle(t);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.silk-fold > .thb-widget-title');
    if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(t); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupFooter); else setupFooter();
  if (mq.addEventListener) mq.addEventListener('change', setupFooter);

  // Mobile sliders show one complete card per view; dots show the position and jump to a card (hidden on desktop by CSS)
  function setupSliders() {
    document.querySelectorAll('.silk-products--slider, .silk-hscroll').forEach(function (track) {
      var items = [].slice.call(track.children);
      if (track.dataset.silkDots || items.length < 2) return;
      track.dataset.silkDots = '1';
      var dots = document.createElement('div');
      dots.className = 'silk-dots';
      var buttons = items.map(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Karte ' + (i + 1) + ' von ' + items.length + ' anzeigen');
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { track.scrollTo({ left: item.offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
        return b;
      });
      track.insertAdjacentElement('afterend', dots);
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var step = items[1].offsetLeft - items[0].offsetLeft || 1;
          var current = Math.min(items.length - 1, Math.round(track.scrollLeft / step));
          buttons.forEach(function (b, i) { if (i === current) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        });
      }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupSliders); else setupSliders();
})();
